// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2DawX","buttons":"SendReceipts_buttons__1J1n0","email":"SendReceipts_email__xasfk","bookApptTitle":"SendReceipts_bookApptTitle__IDbZb"};